import { VueAuthPlugin } from "oidc-vue"
import { defineGlobals } from "vue-utils"
import { useAppConfig } from "./stores/configStore"

const config = useAppConfig()

class AppAuthPlugin extends VueAuthPlugin {
	constructor() {
		super({
			clientId: config.keycloak.clientId,
			authority: config.keycloak.authority,
			redirectUri: window.location.origin,
			postLogoutRedirectUri: window.location.origin,
			storagePrefix: "tfs_",
			sessionExpireLoginType: "popup",
		})
	}

	getKeycloakManageUrl() {
		const realmUrl = this.options.authority
		return `${realmUrl}/account?referrer=${encodeURIComponent(this.options.clientId)}&referrer_uri=${encodeURIComponent(
			window.location.href
		)}`
	}
}

export const AppAuthContext = new AppAuthPlugin()
defineGlobals({
	AppAuthContext,
})
